module.exports = __webpack_public_path__ + "img/dark-space-4.3745c3e5.jpg";